var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLivreBibliotheque(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 150,
    height: 150,
    className: "mainStroke",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30.77,10.93c0-.45-.25-.87-.65-1.08l-1.1-.59c-5.77-3.1-14.83-2.59-19.7-2.31-.93.05-1.67.09-2.14.09-.68,0-1.23.55-1.23,1.23v45.6c0,.33.13.64.36.87s.54.36.87.36c1.62,0,3.28-.08,4.89-.15,5.4-.25,10.98-.5,15.79,2.08l2,1.07c.41.22.9-.08.9-.54V10.93Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.17,7.1c-7.34-2.26-15.43-1.47-22.2,2.17l-1.1.59c-.4.21-.65.63-.65,1.08v46.62c0,.46.49.76.9.54l2-1.07c6.19-3.33,13.6-4.05,20.32-1.98.37.11.78.05,1.09-.19.31-.23.5-.6.5-.99V8.27c0-.54-.35-1.01-.87-1.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivreBibliotheque);
export default __webpack_public_path__ + "static/media/livre-bibliotheque.a423d343cdf9dbaf70f282a9f54a6fbd.svg";
export { ForwardRef as ReactComponent };